import React, { FC } from 'react';
import { getCollectionHandle } from '../../utils/utils';
import {
    NavigationMenuItem,
    DropdownMenuItemProps,
} from '../../models/NavigationMenuItem';
import { Box, styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const HoveredContent = styled(Box)(() => ({
    // display: 'none',
    position: 'absolute',
    top: '99%',
    left: 0,
    zIndex: '10',
    // width: '22rem',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: 'white',
    boxShadow: '0 1px 4px #00000026',
    padding: '5px 0',
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 200ms ease,transform 200ms ease',

    '&.open': {
        // display: 'flex',
        opacity: 1,
        visibility: 'visible',
    },
}));

const BoxItem = styled(Box)(() => ({
    width: '100%',
    padding: '0 20px',

    ':not(:last-child)': {
        a: {
            borderBottom: '1px solid #ededed',
        }
    },
}));

const StyledLink = styled(Link)(() => ({
    display: 'block',
    padding: '10px 0',
}));

export const DropdownNavigationItem: FC<DropdownMenuItemProps> = (props) => {
    const menuItems = props.menuItem;
    const anchorEl = props.anchorEl;
    const open = Boolean(anchorEl);

    const handleClose = () => {
        props.clickHandler();
    };

    const setUrl = (item): string => {
        return item.type == 'COLLECTION'
            ? 'collections/' + getCollectionHandle(item.url)
            : getCollectionHandle(item.url);
    };

    return (
        <HoveredContent className={open ? 'open' : ''}>
            {menuItems.map((item: NavigationMenuItem) => (
                <BoxItem key={item.id} onClick={handleClose}>
                    <StyledLink to={setUrl(item)}>
                        <Typography>{item.title}</Typography>
                    </StyledLink>
                </BoxItem>
            ))}
        </HoveredContent>
    );
};
